import React from 'react';

/**
 * PageHeader - Reusable page header component
 * Matches Payment Links pattern: title + subtitle + action buttons
 */
export function PageHeader({ title, subtitle, actions }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 24,
      }}
    >
      <div>
        <h1
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: 'var(--text-primary, #111827)',
            margin: 0,
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)', marginTop: 4, marginBottom: 0 }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 8 }}>
          {actions}
        </div>
      )}
    </div>
  );
}

/**
 * TableCard - Reusable card wrapper for AG Grid tables
 * Matches Payment Links pattern: card with header (title + count + toolbar) wrapping grid
 */
export function TableCard({ title, count, toolbar, children }) {
  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
        overflow: 'hidden',
      }}
    >
      {/* Card header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          borderBottom: '1px solid var(--border-light, #F3F4F6)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary, #111827)' }}>
            {title}
          </span>
          {count !== undefined && (
            <span
              style={{
                fontSize: 11.5,
                fontWeight: 600,
                color: 'var(--text-secondary, #6B7280)',
                backgroundColor: 'var(--background-paper, #F3F4F6)',
                border: '1px solid var(--border-light, #E5E7EB)',
                borderRadius: '9999px',
                padding: '2px 10px',
              }}
            >
              {count} records
            </span>
          )}
        </div>
        {toolbar}
      </div>

      {/* AG Grid */}
      <div
        className="ag-theme-alpine"
        style={{ height: 520, width: '100%' }}
      >
        {children}
      </div>
    </div>
  );
}
